import { createTheme } from '@mui/material/styles';
import { typography } from './typography';
import { breakpoints } from './breakpoints';
import { components } from './components';

const defaultTheme = createTheme({
  typography,
  components,
  breakpoints,
  palette: {
    background: {
      default: '#9B5DE5',
      secondary: '#ffffff',
    },
    primary: {
      main: '#9B5DE5',
    },
    secondary: {
      main: '#ffffff',
    },
    tertiary: {
      main: '#00F5D4',
    },
    quaternary: {
      main: '#FEE440',
    },
    quintenary: {
      main: '#F05BB5',
    },
    default: {
      main: '#ffffff',
    },
    error: {
      main: '#d32f2f',
    },
    colors: {
      dark: '#121212',
      light: '#ffffff',
    },
  },
});

export default defaultTheme;
